<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Half Title">
<p class="halftitle"><span class="right_1" epub:type="pagebreak" id="page_xiii" title="xiii"><span class="right_1" epub:type="pagebreak" id="page_xiv" title="xiv">MOTOR CITY MOVIE CULTURE, 1916–1925</span></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 00a_fm0c.vue?7dce2de1